var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDashboardIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2500_41550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.71631 15.4284C12.8191 15.4284 16.1449 12.1026 16.1449 7.99986C16.1449 3.89718 12.8191 0.571289 8.71631 0.571289C4.61363 0.571289 1.28774 3.89718 1.28774 7.99986C1.28774 12.1026 4.61363 15.4284 8.71631 15.4284Z",
    stroke: "#D42177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.85917 10.8571H3.85917C4.3896 10.8571 4.89831 10.6464 5.27339 10.2713C5.64846 9.89623 5.85917 9.38751 5.85917 8.85709V7.1428C5.85917 6.61237 6.06988 6.10366 6.44495 5.72858C6.82003 5.35351 7.32873 5.1428 7.85917 5.1428C8.3896 5.1428 8.89831 4.93208 9.27339 4.55701C9.64846 4.18193 9.85917 3.67323 9.85917 3.1428V0.651367",
    stroke: "#D42177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1449 7.88585C15.5727 7.58895 14.9381 7.43227 14.2935 7.42871H11.8592C11.3287 7.42871 10.82 7.63942 10.445 8.01449C10.0699 8.38957 9.85917 8.89828 9.85917 9.42871C9.85917 9.95915 10.0699 10.4679 10.445 10.8429C10.82 11.218 11.3287 11.4287 11.8592 11.4287C12.238 11.4287 12.6015 11.5792 12.8693 11.8471C13.1372 12.115 13.2877 12.4784 13.2877 12.8573V13.8516",
    stroke: "#D42177",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2500_41550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.716309)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDashboardIcon2);
export default __webpack_public_path__ + "static/media/projectDashboardIcon2.af4fed0983a539011e9d66cd9b1168b9.svg";
export { ForwardRef as ReactComponent };